import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

declare let ko: any;

export class amCharts_v4_XY_template extends vnTemplate{
    protected getTemplateHtml(): string{

        return `<div data-bind="attr: {id: idChart}, style: {width: cssWidth, height: cssHeight, display: (show() == true) ? 'block': 'none' }"></div>`;
    }

    public getTemplateName(): string{
        return "amCharts_v4_XY_template";
    }

    protected buildViewModel(): any{

        let _this = this;

        return  {
            idChart: ko.observable("columnChartDiv_" + _this.idElement),
            cssWidth: ko.observable("260px"),
            cssHeight: ko.observable("100px"),
            show: ko.observable(true),
        };
    }

    protected getMainElementClasses(): Array<string>{
        return ["graph"];
    }

    public show(): void {
        this.getTemplateViewModel().show(true);
    }

    public hide(): void {
        this.getTemplateViewModel().show(false);
    }

    public drawChart(chartData) {

        let _this = this;

        am4core.useTheme(am4themes_animated);

        // Create chart instance
        let chart = am4core.create("columnChartDiv_"+_this.idElement, am4charts.XYChart);

        if(chart.logo){

            chart.logo.disabled = true;
        }

        chart.events.on("ready", function(ev) {
            let loadingElement = document.getElementById("chartloading_" + this.idElement);
            if(loadingElement){
                loadingElement.classList.add("is-hidden");
            }
        }, _this);

        chart.data = chartData;

        // Create axes
        var dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;
        dateAxis.renderer.minGridDistance = 30;
        dateAxis.renderer.disabled = true;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

        // Create series
        _this.createSeries(chart,"value2","Projected Active Views Min", "3,3", "#268AF9");
        _this.createSeries(chart,"value3", "Projected Active Views Max", "3,3", "#268AF9");
        _this.createSeries(chart,"value", "Active Views", "", "#2BBCAB");

        // chart.cursor = new am4charts.XYCursor();


    }

    public createSeries(chart, field, name, type, color) {
        var series = chart.series.push(new am4charts.LineSeries());
        //series.showOnInit = false;
        series.dataFields.valueY = field;
        series.dataFields.dateX = "date";
        series.name = name;
        series.strokeWidth = 2;
        series.stroke = am4core.color(color);

        if(type != ""){
            series.strokeDasharray = type;
        }

        series.smoothing = "monotoneX";

        var bullet = series.bullets.push(new am4charts.CircleBullet());
        bullet.circle.stroke = am4core.color(color);
        bullet.fill = am4core.color('#ffffff');
        bullet.circle.strokeWidth = 2;
        bullet.tooltipText = "{dateX}: [bold]{valueY}[/]";

        bullet.adapter.add("tooltipText", (tooltipText, target) => {
            const dataItem = target.dataItem;
            if (dataItem) {
                const date = new Date(dataItem.dateX);
                const formattedDate = this.formatDate(date);
                const valueY = dataItem.valueY;

                return `${formattedDate} - ${name}: [bold]${valueY}[/]`;
            }
            return tooltipText;
        });

        return series;
    }

    public formatDate(dateString) {
        const date = new Date(dateString);
        const day = date.getDate();
        const month = date.toLocaleString('default', { month: 'long' });
        const ordinalSuffix = this.getOrdinalSuffix(day);

        return month + ' ' + day + ordinalSuffix;
    }

    public getOrdinalSuffix(day) {
        if (day >= 11 && day <= 13) {
            return 'th';
        }

        switch (day % 10) {
            case 1:
                return 'st';
            case 2:
                return 'nd';
            case 3:
                return 'rd';
            default:
                return 'th';
        }
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/amCharts_v4_XY_template.ts